
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Budget & Expenses</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="projectId &amp;&amp; projectName"><a [routerLink]="['/project']" [queryParams]="{id: projectId}">{{ projectName }}</a></li>
        <li class="breadcrumb-item active">Budget & Expenses</li>
      </ol>
      <error [error]="error" [ngClass]="{'general-disabled': project?.isMigrationActive}"></error>
    </div>
  </div>
  <div class="row margin-bottom-10" [ngClass]="{'general-disabled': project?.isMigrationActive}">
    <div class="col">
      <div class="btn-group btn-group-sm float-left">
        <button class="btn btn-sm" [ngClass]="amountType === 'usdAmount' ? 'btn-primary' : 'btn-outline-primary'" (click)="setAmountType('usdAmount')">USD</button>
        <button class="btn btn-sm" [ngClass]="amountType !== 'usdAmount' ? 'btn-primary' : 'btn-outline-primary'" (click)="setAmountType('localAmount')" *ngIf="projectCurrency &amp;&amp; projectCurrency !== 'USD'">{{ projectCurrency }}</button>
      </div>
      <div class="btn-group btn-group-sm float-right">
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="chooseCARDAccount()">Change CARD Account</button>
        <button class="btn btn-sm btn-outline-primary" type="button" (click)="importExpenses()">Reload from CARD</button>
        <!--button.btn.btn-sm.btn-primary(type='button', (click)="createExpense()") Log New Expense-->
      </div>
    </div>
  </div>
  <div class="row margin-bottom-10" *ngIf="loading" [ngClass]="{'general-disabled': project?.isMigrationActive}">
    <div class="col">
      <md-spinner-block></md-spinner-block>
    </div>
  </div>
  <div class="row margin-bottom-10" *ngIf="!loading" [ngClass]="{'general-disabled': project?.isMigrationActive}">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="card-item">
            <div class="row">
              <div class="col-12">
                <div class="row text-center">
                  <div class="col">
                    <h2>Summary</h2>
                  </div>
                </div>
                <div class="row text-center">
                  <div class="col-md-4">
                    <h6>Total Budget ({{ currency }})</h6>
                    <h4 class="no-mrg-vertical font-size-35">{{ summary.budget[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</h4>
                  </div>
                  <div class="col-md-4">
                    <h6>Total Expenses ({{ currency }})</h6>
                    <h4 class="no-mrg-vertical font-size-35">{{ summary.expenses[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</h4>
                  </div>
                  <div class="col-md-4">
                    <h6>Remaining Budget ({{ currency }})</h6>
                    <h4 [ngClass]="summary.remaining[amountType] &gt;= 0 ? 'text-success' : 'text-danger'">{{ summary.remaining[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mt-5" *ngFor="let bucket of summary.buckets">
                <div class="row">
                  <div class="col">
                    <div class="btn-group float-right">
                      <button class="btn btn-sm btn-outline-primary" type="button" (click)="showExpenseDetail(bucket.bucket)">Expense Detail</button>
                    </div>
                    <h4>{{ bucket.bucket }}</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <table class="table table-sm table-responsive">
                      <thead>
                        <tr>
                          <th>Month</th>
                          <th>Budget</th>
                          <th>Expense</th>
                          <th>Remaining</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let month of bucket.months" [ngClass]="month.remaining[amountType] &gt;= 0 ? '' : 'table-danger'">
                          <th>{{ month.month }}</th>
                          <th>{{ month.budget[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</th>
                          <th>{{ month.expenses[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</th>
                          <th>{{ month.remaining[amountType] | currency:currency:'symbol-narrow':'1.2-2' }}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col" id="listExpenses" *ngIf="!!currentExpenseBucket">
          <div class="card-item">
            <div class="row">
              <div class="col">
                <h4>Expense Detail: {{ currentExpenseBucket }}</h4>
                <filtered-list-controls class="mt-5" [list]="expenses">
                  <fieldset [disabled]="true">
                    <button class="btn btn-sm btn-outline-primary" (click)="createExpense()" type="button"><span class="oi oi-plus"></span> Add</button>
                  </fieldset>
                </filtered-list-controls>
                <form [formGroup]="expenses.form">
                  <table class="table table-sm table-responsive" formArrayName="items">
                    <thead>
                      <tr class="table-header-with-controls">
                        <th>Month</th>
                        <th>Amount ({{ currency }})</th>
                        <th>Employee</th>
                        <th>Attribute</th>
                        <th>Role</th>
                        <th class="w1pct"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of expenses.filtered" [formGroupName]="item.index">
                        <ng-template [ngIf]="!item.editing" [ngIfElse]="itemEdit">
                          <td>{{ item.month }} ({{ item.period }})</td>
                          <td>{{ item[amountType] | currency:currency:'symbol':'1.2-2' }}</td>
                          <td>{{ item.employeeName }}</td>
                          <td>{{ item.attribute }}</td>
                          <td>{{ item.roleName }}</td>
                        </ng-template>
                        <ng-template #itemEdit>
                          <td colspan="4">EDIT
                            <!--input.form-control.form-control-sm(type='text', formControlName='name')-->
                          </td>
                        </ng-template>
                        <td>
                          <fieldset [disabled]="true">
                            <list-edit-controls [item]="item" [list]="expenses"></list-edit-controls>
                          </fieldset>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>